import React from 'react';
import Locale from '@active/react-utils/i18n/Locale';

export const CheckFieldWarning = ({ id = 'checkout.lib.components.payment.check.different' }) => {
  return <div className="form-group-warning">
    <i className="ic-warning"></i>
    <span id="age-warning" aria-live="assertive">
      <Locale id={id} />
    </span>
  </div>;
};
